module.exports = __webpack_public_path__ + "img/img-17.679a14b0.png";